/** Socket.IO event names. Kept in one file so server and clients can't drift. */
export const RealtimeEvents = {
    TripUpdate: 'trip:update',
    TripFare: 'trip:fare',
    TripOffer: 'trip:offer',
    TripAccept: 'trip:accept',
    TripDecline: 'trip:decline',
    TripArrived: 'trip:arrived',
    TripStart: 'trip:start',
    TripComplete: 'trip:complete',
    DriverLocation: 'driver:location',
    DriverOnline: 'driver:online',
    DriverOffline: 'driver:offline',
    AdminLiveSnapshot: 'admin:live:snapshot',
    AdminLiveTick: 'admin:live:tick',
};
//# sourceMappingURL=realtimeEvents.js.map